import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { QuizMarksSchema } from './MastersSchema';
import { useDispatch, useSelector } from 'react-redux';
import { addUpdateQuizMarksRes, addUpdateQuizMarksTodo } from '../../LMS_Redux/LMS_Slices/Masters/AddUpdateQuizMarks';
import { ToastContainer, toast } from 'react-toastify';
import PropagateLoader from "react-spinners/PropagateLoader";
import "react-data-table-component-extensions/dist/index.css";
import { quizMarksListRes, quizMarksListTodo } from '../../LMS_Redux/LMS_Slices/Masters/QuizMarksList';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { Spinner } from 'react-bootstrap';

export default function QuizMarks() {

    const dispatch = useDispatch()
    const data = useSelector(state => state.quizMarksList && state.quizMarksList.data && state.quizMarksList.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [bool, setBool] = useState(false)
    // console.log(data)

    const initialValues = {
        total: '',
        passing: '',
    };

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'TOTAL MARKS',
            field: 'total_marks',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'PASSING MARKS',
            field: 'passing_marks',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'MIN. %',
            valueGetter: (params) => {
                const passing = params.data.passing_marks;
                const total = params.data.total_marks;
                return ((passing / total) * 100).toFixed(2) + "%";
            },
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            // cellRenderer: params => new Date(params.value).toDateString(),
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
    ]);

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: QuizMarksSchema,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateQuizMarksTodo(values)).then(() => add_update_res(action))
        },
    })

    const add_update_res = (action) => {
        if (addUpdateQuizMarksRes && addUpdateQuizMarksRes.success) {
            toast.success(addUpdateQuizMarksRes.message, { position: "bottom-right" })
            setBool(!bool)
            setSpinner(false)
            action.resetForm()
        } else {
            toast.error(addUpdateQuizMarksRes.message, { position: "bottom-right" })
            setSpinner(false)
        }
    }

    const quiz_marks_list_res = () => {
        if (quizMarksListRes && quizMarksListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(quizMarksListTodo({ status: '' })).then(() => quiz_marks_list_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>Quiz Marks</span>
                </div>

                <div className='wrapper-admin mb-3'>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                        <div className="row">

                            <div className="col-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Total Marks</label>
                                    <input type="text" className="form-control form_input" placeholder="Total Marks in Number"
                                        name='total' value={values.total} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.total && touched.total ? (<span className='text-danger form_label' > {errors.total}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label form_label">Passing Marks</label>
                                    <input type="text" className="form-control form_input" placeholder="Passing Marks in  Number"
                                        name='passing' value={values.passing} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.passing && touched.passing ? (<span className='text-danger form_label'>{errors.passing}</span>) : null}
                                </div>
                            </div>

                            <div className='text-end mt-3'>
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }</button>
                            </div>
                        </div>
                    </form>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }

            </div>
            <ToastContainer />
        </>
    );
}